import { Checkbox, Col, Icon, Row } from 'antd';
import Router, { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Heading from '@/src/shared/components/Heading';
import { space } from '@/styles';
import EditSavedSearch from './EditSavedSearch';
import style from './style';

const { m } = space;

const index = props => {
  const {
    data,
    closeSavedSearchesModal,
    saveCompliassistSearch,
    setRefreshState,
  } = props;

  const [isModalVisible, setModalVisible] = useState(false);

  const dispatch = useDispatch();

  const titleClick = savedSearch => {
    closeSavedSearchesModal();
    if (savedSearch.recentChanges === 'Y') {
      const formattedURL = `/compliance/compliassist/recent-changes?searchId=${savedSearch.searchId}`;
      Router.push(formattedURL, formattedURL, { shallow: true });
      return;
    } else {
      const formattedURL = `/compliance/compliassist?searchId=${savedSearch.searchId}`;
      Router.push(formattedURL, formattedURL, { shallow: true });
    }
  };

  const handleCheckboxChange = () => {
    const newIncludeOnHomePage = data.includeOnHome === 'Y' ? 'N' : 'Y';

    const payload = {
      ...data,
      includeOnHome: newIncludeOnHomePage,
    };

    dispatch(saveCompliassistSearch({ payload }));
  };

  return (
    <Row gutter={16} type="flex" css={m.b16}>
      <EditSavedSearch
        visible={isModalVisible}
        closeModal={() => setModalVisible(false)}
        data={data}
        setRefreshState={setRefreshState}
      />

      <Col xs={14}>
        <Heading
          type={4}
          weight="bold"
          css={style.searchTitle}
          onClick={() => {
            titleClick(data);
          }}
        >
          {data.searchDescription}
        </Heading>
      </Col>

      <Col xs={3}>
        <span css={style.edit} onClick={() => setModalVisible(true)}>
          <Icon type="edit" theme="filled" css={m.r8} />
          <span css={style.editText}>Edit</span>
        </span>
      </Col>

      <Col xs={3}>
        <Checkbox
          css={style.checkbox}
          checked={data.includeOnHome === 'Y'}
          onChange={handleCheckboxChange}
        />
      </Col>
    </Row>
  );
};

index.propTypes = {
  data: PropTypes.object.isRequired,
  closeSavedSearchesModal: PropTypes.func.isRequired,
  saveCompliassistSearch: PropTypes.func.isRequired,
  setRefreshState: PropTypes.func.isRequired,
};

export default withRouter(index);